/**
 * 惩罚原因创建或编辑
 */
import React from 'react';
import {
    Modal,
    message,
    Form,
    Input,
    InputNumber,
    Radio,
    Select
} from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import http from '@/assets/api/http';
// import model from '@/reducers/systemanage/parameter/model';


const FormItem = Form.Item;//表单校验
const formItemLayout = {
    labelCol: {
        sm: { span: 5 },
    },
    wrapperCol: {
        sm: { span: 19 },
    },
};
const { Option } = Select;

class ReasonModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            titleTag: this.props.title,
            visible: this.props.visible,
            confirmLoading: false,
            typeInput: this.props.data === undefined ? '' : this.props.data.className, // 分类名称


        };

    }
    formRef = React.createRef();
    componentDidMount() {
    }

    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }


    handleSubmit = () => {//表单校验
        this.formRef.current.validateFields().then(async(fieldsValue)=>{
                const { name, sortNo, status } = fieldsValue;
                const { data } = this.props;

                let submitData = {
                    id: data ? data.id : undefined,
                    name,
                    sortNo,
                    status,
                };
                let url = data && data.id ? '/?cmd=com.xqxc.api.pig.mis.order.PunishmentTypeService.update' : '/?cmd=com.xqxc.api.pig.mis.order.PunishmentTypeService.add';
                this.setState({ confirmLoading: true }, () => {
                    http(url, submitData, 'POST').then(() => {
                        data ? message.success('更新成功') : message.success('新建成功');
                        this.setState({
                            confirmLoading: false,
                            visible: false,
                        });
                        this.props.closeMode(true);
                    }).catch((e = {}) => {
                        message.error(e.message);
                        this.setState({
                            confirmLoading: false,
                        });
                    });
                });
           
        }).catch(res => {
            
        });
    };


    render() {
        const { visible, confirmLoading, titleTag } = this.state;
        const { data = {} } = this.props;
        const {
            name,
            sortNo,
            status
        } = data;

        return (
            <Modal
                width={470}
                centered
                title={titleTag}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={this.handleSubmit}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form {...formItemLayout} className="create-form" ref={this.formRef}>
                        <FormItem
                            name='name'
                            label='惩罚原因'
                            rules={[{ required: true, message: '请输入惩罚原因', whitespace: true }]}
                            initialValue={name}
                        >
                            <Input maxLength={24} placeholder='请输入' />
                        </FormItem>
                        <FormItem
                            name='sortNo'
                            label='排序'
                            rules={[{ required: true, message: '请输入排序' }]}
                            initialValue={sortNo}
                        >

                            <InputNumber
                                style={{ width: '100%' }}
                                min={1}
                                max={99}
                                precision={0}
                                placeholder='请输入'
                            />

                        </FormItem>
                        <FormItem
                            name='status'
                            label='状态'
                            rules={[{ required: true, message: '请选择状态' }]}
                            initialValue={status}
                        >

                            <Radio.Group>
                                <Radio value={1}>启用</Radio>
                                <Radio value={0}>停用</Radio>
                            </Radio.Group>

                        </FormItem>
                    </Form>
                </div>
            </Modal>
        );

    }
}

ReasonModal.propTypes = {
    data: PropTypes.object, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
};

const mapStateToProps = (state) => {
    return {
        // details: state.parameter.details,
    };
};
export default connect(mapStateToProps)(ReasonModal);